import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { isTokenExpired } from '../utils';
import { useLogout } from './logOut';
import { toast } from 'sonner';

const useTokenExpiryCheck = () => {
  const logout = useLogout();
  useEffect(() => {
    const interval = setInterval(() => {
      const token = Cookies.get('jwt');
      if (isTokenExpired(token)) {
        toast.warning("User Token Expire")
        logout();
      }
    }, 60 * 1000);
    return () => clearInterval(interval);
  }, [logout]);
};

export  {useTokenExpiryCheck};
